import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {Row, Card, CardTitle, Form, Label, Input} from 'reactstrap';
import LoaderButton from '../../components/LoaderButton';
import {Colxx} from '../../components/common/CustomBootstrap';
import {setGoogleAuthStatus} from "../../redux/authUser/actions";
import {Form as FinalForm, Field} from 'react-final-form';
import {required} from "../../helpers/Validators";
import {withTranslation} from 'react-i18next';
import {store} from "../../AppRenderer";
import Api from '../../services/Api';

class GoogleAuth extends Component {
  onSubmit = async (values) => {
    const {history, location} = this.props;
    try {
      await Api.passwordGrant({
        ...location.state.loginValues,
        ...values,
        scope: ["ALL"],
      });
      store.dispatch(setGoogleAuthStatus({
        registered: true,
        enabled: true,
      }));
      history.replace("/dashboard");
    } catch (e) {
      return null;
    }
  };

  render() {
    const {t} = this.props;
    return (
      <FinalForm
        onSubmit={this.onSubmit}
        render={({handleSubmit, pristine, submitting, hasValidationErrors}) => (
          <Row className="h-100">
            <Colxx xxs="12" md="10" className="mx-auto my-auto">
              <Card className="auth-card">
                <div className="position-relative image-side ">
                  <p className="text-white h2">
                    {t('2FA Page')}
                  </p>
                </div>
                <div className="form-side">
                  <NavLink to={'/'} className="white">
                    <span className="logo-single"/>
                  </NavLink>
                  <CardTitle className="mb-4">
                    {t('Copy the related verification code from google authenticator and enter it in the input below.')}
                  </CardTitle>
                  <Form onSubmit={handleSubmit}>
                    <Field name="googleAuthToken" validate={required}>
                      {({input}) => (
                        <div>
                          <Label className="form-group has-float-label mb-4">{t('Verification code')}
                            <Input {...input} type="text"/>
                          </Label>
                        </div>
                      )}
                    </Field>
                    <div className="d-flex justify-content-between align-items-center">
                      <LoaderButton
                        color="primary"
                        size="lg"
                        loading={submitting}
                        disabled={submitting || pristine || hasValidationErrors}
                        onClick={handleSubmit}>
                        {t('Submit')}
                      </LoaderButton>
                    </div>
                  </Form>
                </div>
              </Card>
            </Colxx>
          </Row>
        )}
      />
    );
  }
}

export default withTranslation()(GoogleAuth);
